<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-07-07 11:03:00
 * @LastEditors: lau
 * @LastEditTime: 2022-07-07 14:31:16
-->
<!-- 获取车辆欠费记录 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carNo":  "粤A66666",
                "parkCodeList": ["2KNTYVWC"],
                "paybackStatus": 0,
                "arrearageTimeStart": "20171015000000",
                "arrearageTimeEnd": "20171015141333",
                "paybackTimeStart": "20171015000000",
                "paybackTimeEnd": "20171015141333",
                "pageNum": "1",
                "pageSize": "2"
            },
            responseCode: 	{
                "data": {
                    "currCount": 1,
                    "recordInList": [

                    ],
                    "total": 600
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询车辆异常离场记录",
                t_url: this.commonUrls.test+"getAbnormalOutList",
                p_url: this.commonUrls.prod+"getAbnormalOutList",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号码' },
                        { info1: 'parkCodeList', info2: '是', info3: 'JSONArray', info4: '停车场编号列表' },
                        { info1: 'leaveTimeFrom', info2: '是', info3: 'Integer', info4: '起始离场时间，格式：yyyyMMddHHmmss' },
                        { info1: 'leaveTimeTo', info2: '是', info3: 'String', info4: '截止离场时间，格式：yyyyMMddHHmmss' },
                        { info1: 'pageNum', info2: '否', info3: 'Integer', info4: '第几页，从1开始，默认1' },
                        { info1: 'pageSize', info2: '否', info3: 'Integer', info4: '每页多少条，最多1000条，默认10' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '最终车牌号' },
                        { info1: 'enterCarCode', info2: '是', info3: 'String', info4: '进场车牌号' },
                        { info1: 'leaveCarCode', info2: '否', info3: 'String', info4: '离场车牌号' },
                        { info1: 'enterCardCode', info2: '否', info3: 'String', info4: '进场卡号' },
                        { info1: 'leaveCardCode', info2: '否', info3: 'String', info4: '离场卡号' },
                        { info1: 'enterVipType', info2: '否', info3: 'Integer', info4: '进场vip类型' },
                        { info1: 'enterVipName', info2: '否', info3: 'String', info4: '进场vip类型名称' },
                        { info1: 'enterTime', info2: '否', info3: 'String', info4: '进场时间，格式：yyyyMMddHHmmss' },
                        { info1: 'enterChannelCode', info2: '否', info3: 'String', info4: '进场通道编号' },
                        // { info1: 'enterChannelId', info2: '否', info3: 'String', info4: '进场通道Id' },
                        { info1: 'enterChannelName', info2: '否', info3: 'String', info4: '进场通道名称' },
                        { info1: 'enterOperator', info2: '否', info3: 'String', info4: '进场操作员' },
                        { info1: 'leaveVipType', info2: '否', info3: 'Integer', info4: '离场vip类型' },
                        { info1: 'leaveVipName', info2: '否', info3: 'Integer', info4: '离场vip类型名称' },
                        { info1: 'leaveTime', info2: '否', info3: 'String', info4: '离场时间，格式：yyyyMMddHHmmss' },
                        { info1: 'leaveChannelCode', info2: '否', info3: 'String', info4: '离场通道编号' },
                        { info1: 'leaveChannelName', info2: '否', info3: 'String', info4: '离场通道名称' },
                        { info1: 'leaveOperator', info2: '否', info3: 'String', info4: '离场操作员' },
                        { info1: 'isCorrect', info2: '否', info3: 'String', info4: '车牌是否被校正' },
                        { info1: 'reason', info2: '否', info3: 'String', info4: '异常放行原因' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '异常放行备注' },



                        { info1: 'enterImageArray', info2: '否', info3: 'JSONArray', info4: '进场图片列表' },
                        { info1: 'leaveImageArray', info2: '否', info3: 'JSONArray', info4: '离场图片列表(盘点离场没有图片)' },

                        ]
                },{
                    titleName: 'enterImageArray',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [

                        { info1: 'carImage', info2: '否', info3: 'String', info4: '进场车身图片' },
                        { info1: 'plateImage', info2: '否', info3: 'String', info4: '进场车牌图片' },

                        ]
                },{
                    titleName: 'leaveImageArray',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carImage', info2: '否', info3: 'String', info4: '离场车身图片' },
                        { info1: 'plateImage', info2: '否', info3: 'String', info4: '离场车牌图片' },

                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/record/getAbnormalOutList.vue